// プラットフォーム検出ユーティリティ。
//
// 設計方針:
// - iOS / Android / Desktop 等の「OS 名」と「タッチ主環境か」は別概念として扱う。
// - 直接 `if (isIOS)` を散在させるのではなく、`quirks.ts` 経由で症状軸の判定を行う。
// - UA sniffing は最終手段。可能な限り feature detection と併用する。
//
// 既知の罠:
// - iPadOS 13+ は UA に "Macintosh" を返す（Safari 完全互換を装う）ため、`/iPad/` だけで検出不可。
// - iOS の Chrome / Firefox / Edge は内部が WebKit のため iOS Safari と同じ症状が出る。
//   ブラウザ名ではなく **OS 名で識別**する必要がある。

const isBrowser = typeof navigator !== 'undefined' && typeof window !== 'undefined';

/** iOS / iPadOS 端末かどうか（ブラウザ問わず）。SSR 安全。 */
export const isIOS: boolean = (() => {
  if (!isBrowser) return false;
  const ua = navigator.userAgent || '';
  // iPhone / iPod / 旧 iPad
  if (/iP(hone|od|ad)/.test(ua)) return true;
  // iPadOS 13+（"Macintosh" を返すが maxTouchPoints>1）
  const maxTouchPoints = typeof navigator.maxTouchPoints === 'number'
    ? navigator.maxTouchPoints
    : 0;
  if (/Macintosh/.test(ua) && maxTouchPoints > 1) return true;
  return false;
})();

/** タッチが主操作の環境（iOS / Android / タッチ対応 Chromebook 等）。SSR 安全。 */
export const isTouchPrimary: boolean = (() => {
  if (!isBrowser) return false;
  const mq = window.matchMedia?.('(hover: none) and (pointer: coarse)');
  return mq?.matches === true;
})();

/** iOS PWA standalone モードで起動しているか（apple-mobile-web-app-capable=yes）。 */
export const isIOSStandalone: boolean = (() => {
  if (!isBrowser) return false;
  if (!isIOS) return false;
  // 型定義に navigator.standalone は無いため安全に参照する。
  const nav = navigator as Navigator & { standalone?: boolean };
  return nav.standalone === true;
})();
